import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import FleetReportTypeChooser from '../../fleet/reports/FleetReportTypeChooser';

function FleetReportsPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetReportTypeChooser />
    </FullContainer>
  );
}

export default FleetReportsPage;
